module.exports = __webpack_public_path__ + "img/icon_5_100.98d11daa.png";